'use client'

import { ReactNode, useMemo } from 'react'

import { EscrowFeesModel } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

import EscrowFeesContext from './EscrowFeesContext'

type Props = {
  escrowFees?: EscrowFeesModel | null
  children: ReactNode
}

const EscrowFeesProvider = ({ escrowFees, children }: Props) => {
  const escrowFeesMemo = useMemo(
    () => ({
      escrowFees,
    }),
    [escrowFees],
  )

  return <EscrowFeesContext.Provider value={escrowFeesMemo}>{children}</EscrowFeesContext.Provider>
}

export default EscrowFeesProvider
